let lastRequestId = 0;
const controllers = new Map<number, AbortController>();

export const openRequest = (): number => {
  lastRequestId += 1;
  controllers.set(lastRequestId, new AbortController());
  return lastRequestId;
};

export const requestSignal = (id: number): AbortSignal | undefined => controllers.get(id)?.signal;

export const closeRequest = (id: number): void => {
  controllers.delete(id);
};

export const latestRequestId = (): number => lastRequestId;

export const stopRequestsUpTo = (watermark: number): void => {
  controllers.forEach((controller, id) => {
    if (id <= watermark) controller.abort();
  });
};
